<button
  cari-button
  [cdkMenuTriggerFor]="menu"
  type="button"
  data-shape="squared"
  data-type="neutral"
  data-style="outline"
  data-size="large"
  class="lang-trigger"
  [class.show-icon-only-mobile]="showIconOnlyMobile"
  [attr.aria-label]="'LANDING.FOOTER.CHOOSE_LANGUAGE' | translate"
>
  <!-- Globe Icon Left -->
  <svg
    class="lang-icon-globe"
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
  >
    <path
      d="M325-111.5q-73-31.5-127.5-86t-86-127.5Q80-398 80-480.5t31.5-155q31.5-72.5 86-127t127.5-86Q398-880 480.5-880t155 31.5q72.5 31.5 127 86t86 127Q880-563 880-480.5T848.5-325q-31.5 73-86 127.5t-127 86Q563-80 480.5-80T325-111.5ZM480-162q26-36 45-75t31-83H404q12 44 31 83t45 75Zm-104-16q-18-33-31.5-68.5T322-320H204q29 50 72.5 87t99.5 55Zm208 0q56-18 99.5-55t72.5-87H638q-9 38-22.5 73.5T584-178ZM170-400h136q-3-20-4.5-39.5T300-480q0-21 1.5-40.5T306-560H170q-5 20-7.5 39.5T160-480q0 21 2.5 40.5T170-400Zm216 0h188q3-20 4.5-39.5T580-480q0-21-1.5-40.5T574-560H386q-3 20-4.5 39.5T380-480q0 21 1.5 40.5T386-400Zm268 0h136q5-20 7.5-39.5T800-480q0-21-2.5-40.5T790-560H654q3 20 4.5 39.5T660-480q0 21-1.5 40.5T654-400Zm-16-240h118q-29-50-72.5-87T584-782q18 33 31.5 68.5T638-640Zm-234 0h152q-12-44-31-83t-45-75q-26 36-45 75t-31 83Zm-200 0h118q9-38 22.5-73.5T376-782q-56 18-99.5 55T204-640Z"
    />
  </svg>

  <!-- Current Language Label -->
  <span class="lang-label">{{
    browserLanguage ? browserLanguage.label : fallbackLanguage.label
  }}</span>

  <!-- Chevron Icon Right -->
  <svg
    class="lang-icon-chevron"
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
  >
    <path
      d="M459-381 314-526q-3-3-4.5-6.5T308-540q0-8 5.5-14t14.5-6h304q9 0 14.5 6t5.5 14q0 2-6 14L501-381q-5 5-10 7t-11 2q-6 0-11-2t-10-7Z"
    />
  </svg>
</button>

<ng-template #menu>
  <div class="lang-menu" cdkMenu>
    <button
      *ngFor="let lang of languages"
      class="lang-menu-item"
      type="button"
      [class.is-active]="browserLanguage?.value === lang.value"
      cdkMenuItem
      (click)="changeLanguage(lang.value)"
    >
      {{ lang.label }}
    </button>
  </div>
</ng-template>
